import {observer} from "mobx-react";
import * as React from "react";
import {Comment} from "./Comment";
import {CommentAdd} from "./CommentAdd";

import './CommentBlock.pcss';
import {CommentDataInterface} from "../../../data/FullPostModalData";
import {User} from "../../../data/entities/User";


interface ICommentBlockProps {
  comments:any[];
  addComment:(commentData:CommentDataInterface)=>Promise<void>;
  commentPeriodHasEnded:boolean;
  user:User;
}

@observer
export class CommentBlock extends React.Component<ICommentBlockProps> {

  render(){
    const {comments} = this.props;
    return (
      <div className="comment-block">
        <h2>Comments</h2>
        <div className={"cb-body"}>
          {comments.map((comment, idx) =>
            <Comment key={idx} comment={comment} addReply={this.props.addComment} commentPeriodHasEnded={this.props.commentPeriodHasEnded} />
          )}
          {this.props.commentPeriodHasEnded ?
            <p>Commenting has concluded.</p>
            :
            <CommentAdd addComment={this.props.addComment} user={this.props.user} />
          }
        </div>
      </div>
    );
  }

}
